import { Injectable } from '@angular/core';
import { rethrowAsSapError, SapError } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UnitsOfMeasure } from 'src/app/models/domain';
import { UnitsOfMeasureAdapter } from 'src/app/models/domain/adapters';
import { YPMUOMVCDSYPMUOMVType, YPMUOMVService } from 'src/generated-clients/uom';

@Injectable({
  providedIn: 'root',
})
export class UnitsOfMeasureDataService {
  private readonly materialNumberPropertyName: keyof YPMUOMVCDSYPMUOMVType = 'materialNumber';
  private readonly altUnitPropertyName: keyof YPMUOMVCDSYPMUOMVType = 'altUnit';

  public constructor(
    private readonly unitsOfMeasureService: YPMUOMVService,
    private readonly unitsOfMeasureAdapter: UnitsOfMeasureAdapter
  ) {}

  public getUnitsOfMeasuresByDesignId(designId: string): Observable<UnitsOfMeasure[]> {
    const designIdFilter = `${this.materialNumberPropertyName} eq '${designId}'`;
    const altUnitFilter = `${this.altUnitPropertyName} eq 'PC'`;
    const filter = [designIdFilter, altUnitFilter].join(' and ');

    return this.unitsOfMeasureService.yPMUOMVGet(undefined, undefined, filter).pipe(
      rethrowAsSapError(),
      map((res) => {
        const results = res.d?.results;

        if (results === undefined) {
          throw new SapError('Sap Error');
        }

        return results.map((unitsOfMeasure) =>
          this.unitsOfMeasureAdapter.adaptToDomain(unitsOfMeasure)
        );
      })
    );
  }
}
